var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { attrs: { view: _vm.getView } },
    [
      _c(
        "q-page-container",
        [_c("router-view", { style: _vm.themeStyles })],
        1
      ),
      _c("etraining-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }